import './App.css'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Accueil from './pages/accueil/Accueil'
import APropos from './pages/apropos/APropos'
import Contact from './pages/contact/Contact'
import Parcours from './pages/parcours/Parcours'
import Projets from './pages/projets/intro/Projets'

function App () {
  return (
    <Routes>
      {/* 🔹 Page par défaut */}
      <Route path='/' element={<Accueil />} />

      {/* 🔹 Autres pages */}
      <Route path='/accueil' element={<Accueil />} />
      <Route path='/apropos' element={<APropos />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/parcours' element={<Parcours />} />
      <Route path='/projets/intro' element={<Projets />} />



    </Routes>
  )
}

export default App
